import { h, type FunctionalComponent } from 'vue'

type Props = {
  label: string
  value: string | number
  delta?: string
  deltaColor?: 'good' | 'bad' | 'warn' | 'muted'
  /** override the value's font size, for a denser grid */
  valueSize?: string
}

// Functional: KPI tiles render in grids of up to a dozen. Styles are the .kpi rules
// in assets/css/main.css.
const KpiCard: FunctionalComponent<Props> = (props) =>
  h('div', { class: 'console-card kpi' }, [
    h('div', { class: 'console-label' }, props.label),
    h(
      'div',
      { class: 'kpi-value display mono', style: props.valueSize ? { fontSize: props.valueSize } : undefined },
      String(props.value),
    ),
    props.delta
      ? h('div', { class: 'kpi-delta', style: { color: `var(--${props.deltaColor ?? 'good'})` } }, props.delta)
      : null,
  ])

KpiCard.props = ['label', 'value', 'delta', 'deltaColor', 'valueSize']

export default KpiCard
